import { loadSwiper } from './swiper-loader.js';

if (!customElements.get('featured-reviews')) {
    class FeaturedReviews extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.elSection = this.closest('section');
            this.elPrev = this.querySelector('[data-navigation="prev"]');
            this.elNext = this.querySelector('[data-navigation="next"]');
            this.elCurrent = this.querySelector('[data-current]');
            this.elTotal = this.querySelector('[data-total]');

            this.initCarousel();
        }

        async initCarousel() {
            const Swiper = await loadSwiper();
            this.swiper = new Swiper(this, {
                loop: true,
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                navigation: {
                    nextEl: this.elNext,
                    prevEl: this.elPrev,
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous review',
                    nextSlideMessage: 'Next review',
                },
                on: {
                    slideChange: (s) => {
                        this.elCurrent.textContent = s.realIndex + 1;
                    }
                }
            });

            this.setAttribute('data-swiper-ready', '');
        }
    }

    customElements.define('featured-reviews', FeaturedReviews);
}
